import { ButtonComponent } from '@3ddv/software-division-components/generic/button';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PrivateSellingService } from '@core/services/private-selling.service';
import { environment } from '@environments/environment';
import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import OktaAuth from '@okta/okta-auth-js';
import { OktaContainerComponent } from './components';
import { RedirectPageComponent } from './components/redirect-page/redirect-page.component';
import { OktaIntegrationComponent } from './okta-integration.component';

const oktaAuth = new OktaAuth({
  issuer: `${environment.oktaData.issuer}`,
  clientId: `${environment.oktaData.clientId}`,
  redirectUri: window.location.origin + '/login',
});

@NgModule({
  declarations: [
    OktaIntegrationComponent,
    OktaContainerComponent,
    RedirectPageComponent,
  ],
  imports: [ButtonComponent, CommonModule, OktaAuthModule],
  exports: [OktaContainerComponent],
  providers: [
    { provide: OKTA_CONFIG, useValue: { oktaAuth } },
    PrivateSellingService,
  ],
})
export class OktaIntegrationModule {}
